import axios from './axios';

export const getAccount = async () => {
  const res = await axios({
    method: 'GET',
    url: '/api/account',
  });

  return res.data;
};

export const updateAccount = async (data) => {
  const res = await axios({
    method: 'PUT',
    url: '/api/account',
    data,
  });

  return res.data;
};

export const getAccounts = async (userType) => {
  if (userType !== 'admin') return;
  const res = await axios({
    method: 'GET',
    url: '/api/account/all',
  });

  return res.data;
};

export const updateAccountById = async ({ userType, userId, data }) => {
  if (userType !== 'admin') return;

  const res = await axios({
    method: 'PUT',
    url: `/api/account/${userId}`,
    data,
  });

  return res.data;
};
